<template>
  <div>
    <h3 class="myOrangeTitle" v-html="$t('views.compagnyView.workUnit.title')"></h3>
    <p v-html="'<span class=\'asterisk\'>* </span>'+$t('views.compagnyView.msgRequiredFields')"></p>
    <b-form>
      <b-form-group :state="name" :invalid-feedback="invalidFeedbackName">
        <label
          class="label-class"
          v-html="$t('views.compagnyView.workUnit.name.label')+' <span class=\'asterisk\'>*</span>'"
        ></label>
        <b-form-input
          class="myinput"
          ref="name"
          maxlength="200"
          v-if="!printMode"
          v-model="compagnyForm.name"
          :placeholder="$t('views.compagnyView.workUnit.name.placeholder')"
          trim
        ></b-form-input>
        <span 
          v-if="printMode"
          class="printedField text"
        >{{compagnyForm.name}}</span>
      </b-form-group>

      <b-form-group :state="unitname" :invalid-feedback="invalidFeedbackUnitName">
        <label class="label-class" for="inputUnitName">
          {{ $t('views.compagnyView.workUnit.unitName.label') }}
          <span class="asterisk">*</span>
        </label>

        <help-circle-icon 
          v-if="!printMode && $t('views.compagnyView.workUnit.unitName.tooltip')"
          class="icon-tooltip"
          title="" 
          v-tooltip="$t('views.compagnyView.workUnit.unitName.tooltip')"
        />          

        <b-form-input
          class="myinput"
          ref="unitname"
          maxlength="200"
          v-if="!printMode"
          id="inputUnitName"
          v-model="compagnyForm.unitName"
          :placeholder="$t('views.compagnyView.workUnit.unitName.placeholder')"
        ></b-form-input>
        <span 
          v-if="printMode"
          class="printedField text"
        >{{compagnyForm.unitName}}</span>
      </b-form-group>

      <b-form-group
        label-class="form-group-label"
        :label="$t('views.compagnyView.workUnit.unitWorkcomment.label')"
      >
        <b-form-textarea
          class="myinput"
          v-if="!printMode"
          v-model="compagnyForm.unitWorkcomment"
          rows="3"
          max-rows="6"
          maxlength="1000"
          :placeholder="$t('views.compagnyView.workUnit.unitWorkcomment.placeholder')"
        ></b-form-textarea>
        <span 
          v-if="printMode"
          class="printedField textarea"
        >{{compagnyForm.unitWorkcomment}}</span>
      </b-form-group>

      <h3 class="myOrangeTitle" v-html="$t('views.compagnyView.evalWorkOrganisation.title')"></h3>

      <div id="stakeholdersBlock">
        <h5 class="form-title firstAfterTitle">
          {{ $t('views.compagnyView.evalWorkOrganisation.stakeholders.title.label') }}
        </h5>

        <div class="formBlock" ref="stakeholdersList" id="stakeholdersList">
          <div class="iterated-row row-stakeholder" v-for="(item,index) in compagnyForm.stakeholders" :key="index">
            <div v-if="!printMode" class="delete-button">
              <inrs-delete-icon class="big clickable" :title="$t('global.trashBtnTitle')" @click="compagnyForm.stakeholders.splice(index,1)" />
            </div>

            <b-row>
              <div class="row-field field-name">
                <b-form-group>
                  <label
                    class="label-class"
                    v-html="$t('views.compagnyView.evalWorkOrganisation.stakeholders.name.label')"
                  ></label>
                  <b-form-input
                    class="myinput"
                    v-if="!printMode"
                    v-model="item.name"
                    maxlength="100"
                    :placeholder="$t('views.compagnyView.evalWorkOrganisation.stakeholders.name.placeholder')"
                  ></b-form-input>
                  <span 
                    v-if="printMode"
                    class="printedField text"
                  >{{item.name}}</span>
                </b-form-group>
              </div>
              <div class="row-field field-function">
                <b-form-group>
                  <label
                    class="label-class"
                    v-html="$t('views.compagnyView.evalWorkOrganisation.stakeholders.function.label')"
                  ></label>
                  <b-form-input
                    class="myinput"
                    v-if="!printMode"
                    v-model="item.function"
                    maxlength="100"
                    :placeholder="$t('views.compagnyView.evalWorkOrganisation.stakeholders.function.placeholder')"
                  ></b-form-input>
                  <span 
                    v-if="printMode"
                    class="printedField text"
                  >{{item.function}}</span>
                </b-form-group>
              </div>
              <div class="row-field field-involvementMode">
                <b-form-group>
                  <div class="labelAndHelp">
                    <label
                      class="label-class"
                      for="inputInvolvementMode"
                    >
                      {{ $t('views.compagnyView.evalWorkOrganisation.stakeholders.involvementMode.label') }}
                    </label>
                  </div>

                  <b-form-textarea
                    class="myinput"
                    id="inputInvolvementMode"
                    v-if="!printMode"
                    v-model="item.involvementMode"
                    rows="3"
                    max-rows="6"
                    maxlength="1000"
                    :placeholder="$t('views.compagnyView.evalWorkOrganisation.stakeholders.involvementMode.placeholder')"
                  ></b-form-textarea>
                  <span 
                    v-if="printMode"
                    class="printedField textarea"
                  >{{item.involvementMode}}</span>
                </b-form-group>
              </div>
            </b-row>
          </div>

          <button
            v-if="!printMode"
            type="button"
            class="refonte_btn-add-icon"
            @click="addStakeholder()"
          >
            <img src="icons/circle-plus-solid-full.svg" alt="" />{{ $t('views.compagnyView.evalWorkOrganisation.stakeholders.addPerson') }}
          </button>
        </div>
      </div>

      <b-row class="block-achievementDates-infoCollectMode">
        <div class="block-achievementDates">
          <h5 class="form-title" v-html="$t('views.compagnyView.evalWorkOrganisation.achievementDates.title')"></h5>
          <div class="formBlock">
            <b-form-group :state="currentdate" :invalid-feedback="invalidFeedbackCurrentDate">
              <label
                class="label-class"
                v-html="$t('views.compagnyView.evalWorkOrganisation.achievementDates.currentDate.label')+' <span class=\'asterisk\'>*</span>'"
              ></label>
              <b-form-input
                class="myinput"
                ref="currentdate"
                v-if="!printMode"
                v-model="compagnyForm.completionPeriods.currentDate"
                maxlength="50"
                :placeholder="$t('views.compagnyView.evalWorkOrganisation.achievementDates.currentDate.placeholder')"
              ></b-form-input>
              <span 
                v-if="printMode"
                class="printedField textarea"
              >{{compagnyForm.completionPeriods.currentDate}}</span>
            </b-form-group>
            <b-form-group
              label-class="form-group-label"
              :label="$t('views.compagnyView.evalWorkOrganisation.achievementDates.previousDate.label')"
            >
              <b-form-input
                class="myinput"
                v-if="!printMode"
                v-model="compagnyForm.completionPeriods.previousDate"
                maxlength="50"
                :placeholder="$t('views.compagnyView.evalWorkOrganisation.achievementDates.previousDate.placeholder')"
              ></b-form-input>
              <span 
                v-if="printMode"
                class="printedField textarea"
              >{{compagnyForm.completionPeriods.previousDate}}</span>
            </b-form-group>
          </div>
        </div>

        <div class="block-infoCollectMode">
          <h5 class="form-title" v-html="$t('views.compagnyView.evalWorkOrganisation.infoCollectMode.title')"></h5>

          <div class="formBlock" ref="infoCollectBlock" id="infoCollectBlock">
            <div class="iterated-row row-infoCollectMode" v-for="(item,index) in compagnyForm.informationCollect" :key="index">
              <div v-if="!printMode" class="delete-button">
                <inrs-delete-icon class="big clickable" :title="$t('global.trashBtnTitle')" @click="compagnyForm.informationCollect.splice(index,1)" />
              </div>

              <b-row>
                <div class="row-field field-name">
                  <b-form-group>
                    <label
                      class="label-class"
                      label-class="form-group-label"
                      v-html="$t('views.compagnyView.evalWorkOrganisation.infoCollectMode.event.name.label')"
                    ></label>
                    <b-form-textarea
                      class="myinput"
                      v-if="!printMode"
                      v-model="item.event"
                      rows="2"
                      max-rows="6"
                      maxlength="1000"
                      :placeholder="$t('views.compagnyView.evalWorkOrganisation.infoCollectMode.event.name.placeholder')"
                    ></b-form-textarea>
                    <span 
                      v-if="printMode"
                      class="printedField textarea"
                    >{{item.event}}</span>
                  </b-form-group>
                </div>
                <div class="row-field field-date">
                  <b-form-group>
                    <label
                      class="label-class"
                      v-html="$t('views.compagnyView.evalWorkOrganisation.infoCollectMode.event.date.label')"
                    ></label>
                    <b-form-input
                      class="myinput"
                      v-if="!printMode"
                      v-model="item.period"
                      maxlength="50"
                      :placeholder="$t('views.compagnyView.evalWorkOrganisation.infoCollectMode.event.date.placeholder')"
                    ></b-form-input>
                    <span 
                      v-if="printMode"
                      class="printedField text"
                    >{{item.period}}</span>
                  </b-form-group>
                </div>
              </b-row>
            </div>
            <button
              v-if="!printMode"
              type="button"
              class="refonte_btn-add-icon"
              @click="addEvent()"
            >
              <img src="icons/circle-plus-solid-full.svg" alt="" />{{ $t('views.compagnyView.evalWorkOrganisation.infoCollectMode.event.add') }}
            </button>
          </div>
        </div>
      </b-row>

      <b-form-group
        class="block-evaluationWorkComment"
        label-class="form-group-label"
        :label="$t('views.compagnyView.evalWorkOrganisation.evaluationWorkComment.label')"
      >
        <b-form-textarea
          class="myinput"
          v-if="!printMode"
          v-model="compagnyForm.evaluationWorkComment"
          rows="3"
          max-rows="6"
          maxlength="1000"
          :placeholder="$t('views.compagnyView.evalWorkOrganisation.evaluationWorkComment.placeholder')"
        ></b-form-textarea>
        <span 
          v-if="printMode"
          class="printedField textarea"
        >{{compagnyForm.evaluationWorkComment}}</span>
      </b-form-group>

      <div v-if="!printMode" class="btn-container">
        <button
          type="button"
          class="refonte_btn-primary saveBtn"
          @click="saveCompagnyForm('themesList')"
        >
          <img src="icons/themes.png" />{{ $t('views.compagnyView.endButton') }}
        </button>
      </div>
    </b-form>
  </div>
</template>

<script>
import PlusIcon from 'vue-material-design-icons/Plus.vue';
import HelpCircleIcon from 'vue-material-design-icons/HelpCircle.vue';
import InrsDeleteIcon from '../../icons/InrsDelete.vue';

export default {
  name: "Compagnyform",
  components: {
    PlusIcon,
    HelpCircleIcon,
    InrsDeleteIcon
  },
  props: {
    printMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // les 4 fonctions suivantes servent à gérer les messages d'erreur liés aux champs obligatoires
    name: function() {
      return this.compagnyForm.name.length >= 1 ? true : false;
    },
    unitname: function() {
      return this.compagnyForm.unitName.length >= 1 ? true : false;
    },
    currentdate: function() {
      return this.compagnyForm.completionPeriods.currentDate.length >= 2
        ? true
        : false;
    },
    invalidFeedbackName: function() {
      if(!this.name &&this.testContent) 
        return this.$i18n.t("views.compagnyView.workUnit.name.error");
      return ""
    },
    invalidFeedbackUnitName: function() {
      if(!this.unitname && this.testContent)
          return this.$i18n.t("views.compagnyView.workUnit.unitName.error");
      return ""
    },
    invalidFeedbackCurrentDate: function() {
      if(!this.currentdate && this.testContent)
          return this.$i18n.t("views.compagnyView.evalWorkOrganisation.achievementDates.currentDate.error");
      return ""
    },
    currentCompagnyForm: function() {
      return this.$store.state.gpsstModule.gpsst.compagnyContext;
    },
    tryValidateCompagny: function() {
      return this.$store.state.appState.tryValidateCompagny;
    }
  },
  // on initialise les données avec celles déjà existantes
  created: function() {
    if (this.currentCompagnyForm) {
      this.compagnyForm = this.currentCompagnyForm;
    }

    // Ajout de lignes vides aux listes vides
    if (!this.compagnyForm.stakeholders.length) {
      this.compagnyForm.stakeholders.push({'name': "", 'function': "", 'involvementMode': ""});
    }
    if (!this.compagnyForm.informationCollect.length) {
      this.compagnyForm.informationCollect.push({'event': "", 'period': ""});
    }
  },
  mounted: function() {
    if (!this.printMode) {
      // on met le focus sur le premier input
      this.$refs.name.$el.focus();
    }
  },
  watch: {
    // si l'utilisateur charge un nouveau fichier les champs sont remplis avec le contenu du fichier
    currentCompagnyForm: function() {
      this.compagnyForm = this.currentCompagnyForm;
    },
    tryValidateCompagny: function() {
      if (this.tryValidateCompagny) {
        // detecter par le store le besoin d'exécuter la fonction de validation du formulaire
        this.$store.commit("SET_TRY_VALIDATE_COMPAGNY", false);
        this.saveCompagnyForm();
      }
    }
  },
  data: function() {
    return {
      testContent: false,
      compagnyForm: {
        name: "",
        unitName: "",
        unitWorkcomment: "",
        stakeholders: [{ name: "", function: "", involvementMode: "" }],
        completionPeriods: {
          currentDate: "",
          previousDate: ""
        },
        informationCollect: [{ event: "", period: "" }],
        evaluationWorkComment: ""
      }
    };
  },
  methods: {
    addStakeholder: async function() {
      this.compagnyForm.stakeholders.push({name:'', function:'', involvementMode:''});

      // on met le focus sur le premier input de la nouvelle ligne
      await this.$nextTick();
      $("#stakeholdersList .row-stakeholder").last().find(".myinput").first().focus(); //eslint-disable-line no-undef
    },
    addEvent: async function() {
      this.compagnyForm.informationCollect.push({event:'', period:''})
      // on met le focus sur le premier input de la nouvelle ligne
      await this.$nextTick(); 
      $("#infoCollectBlock .row-infoCollectMode").last().find(".myinput").first().focus(); //eslint-disable-line no-undef
    },
    saveCompagnyForm: function(nextView) {
      this.testContent = true
      if (this.compagnyForm.name.length < 2) {
        this.$refs.name.$el.focus();
        return;
      }

      if (this.compagnyForm.unitName.length < 2) {
        this.$refs.unitname.$el.focus();
        return;
      }

      if (this.compagnyForm.completionPeriods.currentDate.length < 2) {
        this.$refs.currentdate.$el.focus();
        return;
      }

      this.removeEmptyElementsFromList(this.compagnyForm.stakeholders, ['name', 'function', 'involvementMode']);
      this.removeEmptyElementsFromList(this.compagnyForm.informationCollect, ['event', 'period']);

      // Le store et le sessionStorage sont mis à jour avec les nouvelles données
      this.$store.dispatch("overwriteCompagnyContext", this.compagnyForm);

      // Activation de l'accès aux thèmes
      this.$store.commit("VALIDATE_COMPAGNY_COMPLETED");

      // On définit la prochaine vue seulement après validation réussie
      if (nextView) {
        this.$store.commit('SET_NEXT_VIEW_AFTER_COMPAGNY', nextView);
      }

      // Changement de view pour arriver sur la liste des thèmes
      this.$emit("end");
    },

    /**
     * Supprime les éléments vides d'une liste saisie par l'utilisateur
     * 
     * @param {Array.<object>} list - liste à nettoyer
     * @param {Array.<string>} properties - propriétés à tester
     */
    removeEmptyElementsFromList : function(list, properties) {
      var i=0;
      while(i < list.length) {
        let elt = list[i], empty=true;
        
        for (const prop of properties) {
          empty = empty && !elt[prop];
        }

        if (empty) {
          list.splice(i, 1);
        }
        else {
          i++;
        }
      }
    }
  }
};
</script>

<style lang="sass" scoped>
@import "../../sass/_variables.sass"
@import "../../sass/_media.sass"

.delete-icon
  align-self: start

.formBlock 
  background-color: $lightgray-3
  padding: 1em  

  @media print
    background: #fff
    border: 1px solid $lightgray-1

.btn-container
    display: flex
    justify-content: center
    flex-wrap: wrap
    gap: 20px
    margin: 2em

.label-class
  font-weight: bold

.form-title
  color: #161616
  font-weight: bold
  font-size: 1.54em
  margin-top: 1.5em
  
  &.firstAfterTitle
    margin-top: 0.5em

.saveBtn
  font-weight: bold
  font-size:1.3em
  height: 50px

.asterisk
  color: $red-info

.row
  margin: 0

label
  margin-bottom: 0.25em

.iterated-row
  position: relative
  padding: 0.7em 3em 0.7em 0
  border-top: 1px solid $lightgray-1

  &:first-child
    margin-top: -0.7em
    border-top: none

  .delete-button
    position: absolute
    top: 0.7em
    right: 0

  .form-group
    margin: 0

  .row-field
    padding: 0
    margin: 0 1.5em 0 0
    
    &:last-child
      margin-right: 0

#stakeholdersBlock, #stakeholdersList
  break-inside: avoid
  page-break-inside: avoid

.row-stakeholder
  &:first-child
    .labelAndHelp
      display: block !important

  .row-field
    .labelAndHelp
      display: none      
      @include md
        display: block

    &.field-name 
      flex-grow: 3
      @include md
        margin-bottom: 1em
      @include sm
        width: 100%
        margin-right: 0 

    &.field-function 
      flex-grow: 3
      @include md
        margin-right: 0 
        margin-bottom: 1em
      @include sm
        width: 100%

    &.field-involvementMode
      flex-grow: 4
      @include md
        width: 100%

  @media print
    display: table
    width: 100%
    .row
      display: table-row

      .row-field
        display: table-cell
        vertical-align: top

        &.field-name
          width: 25%

        &.field-function
          width: 35%

        &.field-involvementMode
          width: 40%

.block-achievementDates-infoCollectMode
  padding: 0

  .block-achievementDates
    display: inline-block
    padding-right: 1em
    width: 40%
    break-inside: avoid
    page-break-inside: avoid

    @include md
      padding-right: 0
      width: 100%


  .block-infoCollectMode
    display: inline-block
    padding-left: 1em
    width: 60%

    @include md
      padding-left: 0
      width: 100%



.row-infoCollectMode
  &:first-child
    .label-class
      display: block !important

  .row-field
    .label-class
      display: none      
      @include sm
        display: block

  .row-field
    flex-grow: 3

    @include sm
      width: 100%
      margin-right: 0 
      margin-bottom: 1em

      &:last-child
        margin-bottom: 0

  @media print
    display: table
    width: 100%
    .row
      display: table-row

      .row-field
        display: table-cell
        width: 50%
        vertical-align: top


.block-evaluationWorkComment
  margin: 1.5em 0 0 0


</style>
